import React, { SVGProps } from "react";

interface CloseIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const CloseIcon: React.FC<CloseIconProps> = ({
  className,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M18 6L6 18M6 6L18 18"
        stroke="#A9A29D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
